<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="area_wrap">
          <div class="aw_blank request">
            <div class="center_text">
              <p>제증명 발급 신청이 완료되었습니다.</p>
              <p>방문시 <b class="red">본인 신분증 지참</b>하시기 바랍니다.</p>
              <p>[신청내역 조회]에서 신청 내역과 지불금액을</p>
              <p>확인 후 방문하시기 바랍니다.</p>
            </div>
          </div>
          <div class="small_btnWrap one request">
            <router-link to="./certificateReference">
              <button type="button" class="red">대리인 수령방법</button>
            </router-link>
          </div>
        </div>
      </div>
      <div class="btnWrap visible" :class="{half : halfFlag}">
        <router-link to="./certificateLookupList">
          <button type="button" class="callTerms cancel">신청내역 조회</button>
        </router-link>
        <router-link to="/">
          <button type="button" class="callTerms">메인페이지</button>
        </router-link>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single'
      },
      transDate: {
        headerName: '제증명 발급 신청하기',
        prevUrl: '/'
      },
      halfFlag: true,
      setCount: false
    }
  },
  created () {
    /* url 직접 접근 막기 */
    if (this.getReferrer.includes('certificateRequest') !== true) {
      this.SET_POPUP(true)
      this.popupSet.content = '잘못된 접근입니다.'
      this.popupSet.count = 'another'
      this.popupSet.nextLink = '/'
      this.popupSet.closeType = 'action'
      this.popupSet.closeLink = '/'
    }
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  computed: {
    ...mapGetters([

    ]),
    ...mapGetters('referrer', [
      'getReferrer'
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapMutations('referrer', [
      'SET_REFERRER'
    ]),
    ...mapActions([
    ]),
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  beforeDestroy () {
    this.setCount = false
    this.SET_POPUP(false)
    this.SET_REFERRER('')
  }
}
</script>

<style lang="scss" scoped>
</style>
